import { Component, Injectable, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';

@Component({
    selector: 'compare-versions',
    templateUrl: './compare-versions.component.html',
    styleUrls: ['./compare-versions.component.scss']
})
export class CompareVersionsComponent implements OnInit {
    constructor(private dialogRef: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {}


    private _isPopup: boolean = false;
    public get isPopup(): boolean {
        return this._isPopup;
    }
    public set isPopup(value: boolean) {
        this._isPopup = value;
    }

    public get title(): string {
        if (this.data.title != null) {
            return this.data.title;
        }
        return "";
    }

    ngOnInit() {
        
    }

    closeAction() {
        if (this.isPopup)
            this.dialogRef.closeAll();

    }


}

@Component({
    selector: 'compare-versions-page',
    templateUrl: './compare-versions.component.html',
    styleUrls: ['./compare-versions.component.scss']
})
export class CompareVersionsPageComponent implements OnInit {
    constructor(private dialogRef: MatDialog) { }


    private _isPopup: boolean = false;
    public get isPopup(): boolean {
        return this._isPopup;
    }
    public set isPopup(value: boolean) {
        this._isPopup = value;
    }

    get title(): string {
        return "";
    }

    closeAction() { }

    ngOnInit() {

    }
}

